import React from 'react';

import { LinkProps } from 'Elements/Link';

import {
    Container,
    Heading,
    List,
    ListItem,
    NavigationWrapper,
    Wrapper,
    NavLink
} from './Strategy.styled';

import Accordion from 'Components/Accordion';

export interface Props {
    heading: string;
    links: LinkProps[];
}

const Strategy: React.FC<Props> = ({ links, heading }) => {
    const Navigation = (
        <Container>
            <Heading>{heading}</Heading>
            <List>
                {links.map((link, index) => (
                    <ListItem key={`strat-nav-link-${index}`}>
                        <NavLink {...link} />
                    </ListItem>
                ))}
            </List>
        </Container>
    );

    return (
        <Wrapper>
            <Accordion
                children={Navigation}
                heading={heading}
                button={{ ariaLabel: 'Strategy navigation menu' }}
                id="stratNavigation"
            />

            <NavigationWrapper>{Navigation}</NavigationWrapper>
        </Wrapper>
    );
};

export default Strategy;
